/**
 * Multimedia (file upload) constants for support tickets
 * Centralized configuration for file validation.
 * Note: MIME-type validation is handled on the backend only.
 * Client-side MIME checks are unreliable and can be spoofed.
 */
export const MultimediaConstants = Object.freeze({
    // Maximum number of files per ticket
    MAX_FILE_COUNT: 5,

    // Maximum file size in MB
    MAX_FILE_SIZE_MB: 10
});

export default MultimediaConstants;
